/** * Created by lobin on 2019/2/1. */
<template>
  <div class="education-edit">
    <el-form
      :model="educationalBackground"
      ref="educational"
      label-width="100px"
      class="myresume-form"
      :rules="rules"
      label-position="right"
    >
      <el-row :gutter="20">
        <el-col :span="16">
          <el-form-item label="学校名称：" prop="schoolName">
            <el-input
              v-model="educationalBackground.schoolName"
              placeholder="请输入学校名称"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item label="学历：" prop="qualificationsType">
            <el-select
              v-model="educationalBackground.qualificationsType"
              placeholder="请选择最高学历"
            >
              <el-option
                :label="item.name"
                v-for="item in qualificationsType"
                :key="item.code"
                :value="item.code"
                >{{ item.name }}</el-option
              >
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item label="学校类型：" prop="schoolType">
            <el-select
              v-model="educationalBackground.schoolType"
              placeholder="请选择学校类型"
            >
              <el-option
                :label="item.name"
                v-for="item in schoolType"
                :key="item.code"
                :value="item.code"
                >{{ item.name }}</el-option
              >
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item label="是否统招：" prop="unified">
            <el-radio-group v-model="educationalBackground.unified">
              <el-radio :label="true">统招</el-radio>
              <el-radio :label="false">非统招</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item label="所学专业：" prop="majorSubjects">
            <el-input
              v-model="educationalBackground.majorSubjects"
              placeholder="请输入专业"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item label="入学时间：" prop="startTime">
            <el-date-picker
              type="month"
              placeholder="入学时间"
              v-model="educationalBackground.startTime"
              value-format="yyyy-MM"
              :picker-options="pickerOptionsStart"
              style="width: 100%;"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item label="毕业时间：" prop="endTime">
            <el-date-picker
              type="month"
              placeholder="毕业时间"
              v-model="educationalBackground.endTime"
              :picker-options="pickerOptionsEnd"
              value-format="yyyy-MM"
              style="width: 100%;"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="24" style="text-align: center">
          <el-button @click="next">{{ cancelText }}</el-button>
          <el-button type="primary" @click="addEducationAction">保存</el-button>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script type="text/babel">
import { mapGetters, mapActions } from "vuex";
export default {
  props: ["value", "index", "type", "cancelText"],
  data() {
    return {
      educationalBackground: {}
    };
  },
  created() {
    this.educationalBackground = this.value;
  },
  computed: {
    ...mapGetters(["qualificationsType", "schoolType"]),
    rules() {
      return {
        schoolName: [
          { required: true, trigger: "blur", message: "学校名称必填" }
        ],
        qualificationsType: [
          { required: true, trigger: "change", message: "学历必填" }
        ],
        schoolType: [
          { required: true, trigger: "change", message: "学校类型必选" }
        ],
        majorSubjects: [
          { required: true, trigger: "blur", message: "专业必填" }
        ],
        startTime: [
          { required: true, trigger: "change", message: "上学时间必填" }
        ],
        endTime: [
          { required: true, trigger: "change", message: "毕业时间必填" }
        ],
        unified: [
          { required: true, trigger: "change", message: "是否统招必选" }
        ]
      };
    },
    educationRules() {
      return {};
    },
    // pickerOptions(){
    // 	let arr = [];
    // 	for(let val of this.)
    // },
    // 时间结束判断
    pickerOptionsEnd() {
      const _this = this;
      return {
        disabledDate(time) {
          if (_this.educationalBackground.startTime) {
            return (
              time.getTime() <=
              new Date(_this.educationalBackground.startTime).getTime()
            );
          } else {
            return false;
          }
        }
      };
    },
    // 时间起始判断
    pickerOptionsStart() {
      const _this = this;
      return {
        disabledDate(time) {
          if (_this.educationalBackground.endTime) {
            return (
              time.getTime() >=
                new Date(_this.educationalBackground.endTime).getTime() ||
              time.getTime() > Date.now() - 8.64e6
            );
          } else {
            return time.getTime() > Date.now() - 8.64e6;
          }
        }
      };
    }
  },
  methods: {
    ...mapActions(["addEducation", "editEducation"]),
    async addEducationAction() {
      const validate = await this.$refs["educational"].validate();
      if (!validate) return;
      const actionType = this.type == "edit" ? "editEducation" : "addEducation";
      const res = await this[actionType](this.educationalBackground);
      if (res.code === 200) {
        if (this.type !== "edit") {
          this.$emit("input", res.data);
        }
        this.$emit("submit", this.index);
        this.$message.success("成功");
      } else {
        this.$message.error(res.message);
      }
    },
    next() {
      this.$emit("submit", this.index);
    }
  }
};
</script>

<style lang="less" rel="stylesheet/less">
.education-edit {
  background: #F2F6FA;
  border-radius: 6px;
  padding: 24px;
}
</style>
